'use client';

import { usePathname, useRouter } from '@/i18n/routing';
import { useLocale } from 'next-intl';

export function useSwitchLocale() {
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();

  return () => {
    const nextLocale = locale === 'en' ? 'ar' : 'en';
    const query = Object.fromEntries(
      new URLSearchParams(window.location.search).entries(),
    );
    router.replace(
      Object.keys(query).length > 0 ? { pathname, query } : pathname,
      { locale: nextLocale },
    );
  };
}
